export var PQ4castDataType;
(function (PQ4castDataType) {
    PQ4castDataType[PQ4castDataType["Voltage"] = 1] = "Voltage";
    PQ4castDataType[PQ4castDataType["Ptot"] = 2] = "Ptot";
    PQ4castDataType[PQ4castDataType["Qtot"] = 3] = "Qtot";
    PQ4castDataType[PQ4castDataType["ThdU"] = 4] = "ThdU";
    PQ4castDataType[PQ4castDataType["UnbU"] = 5] = "UnbU";
    PQ4castDataType[PQ4castDataType["Temperature"] = 6] = "Temperature";
    PQ4castDataType[PQ4castDataType["Frequency"] = 7] = "Frequency";
    PQ4castDataType[PQ4castDataType["UNKNOWN"] = -1] = "UNKNOWN";
})(PQ4castDataType || (PQ4castDataType = {}));
